<div class="header">
  <h5 style="font-size: 20px; margin: 0">Request for Proposal (RFP)</h5>
  <img
    src="assets/icons/cross-icon.svg"
    alt="cross icon"
    class="crossicon"
    (click)="closeDialog()"
  />
</div>


<div class="mx-[2.3rem] mt-[0.85rem]">
  <h1
    class="header-label"
  >
    Evaluation Form with Evaluation Criteria
  </h1>

   <h2
      class="header-label !mt-[1.06rem] "
    >
      Tender Information
    </h2>
  <div class="border p-4 mb-6 mt-[0.75rem]">
   
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8 pl-[14px]">
      <div class="flex items-center">
        <label
          class="header-label !text-[#343A40] !w-[240px] pb-3"
          >Tender Name</label
        >
        <p class="!text-[1rem]">{{ tenderInfo?.tenderer_name  }}</p>
      </div>
      <div class="flex items-center">
        <label
          class="header-label !text-[#343A40] !w-[240px] pb-3"
          >Position</label
        >
        <p class="!text-[1rem]">{{ tenderInfo?.tenderer_position  }}</p>
      </div>
      <div class="flex items-center">
        <label
          class="header-label !text-[#343A40] !w-[240px] pb-3"
          >Company Name</label
        >
        <p class="!text-[1rem]">{{ tenderInfo?.tenderer_company_name  }}</p>
      </div>
      <div class="flex items-center">
        <label
          class="header-label !text-[#343A40] !w-[240px] pb-3"
          >Contact Info</label
        >
        <p class="!text-[1rem]">Phone: {{ tenderInfo?.tenderer_contact_information  }}</p>
      </div>
    </div>
  </div>
</div>

<div class="mx-[2.3rem] pb-6 ">
<ng-container *ngIf="currentStep === 1">
  <app-technical-evaluation-criteria
    [data]="data"
  ></app-technical-evaluation-criteria>
  </ng-container>
  <ng-container *ngIf="currentStep === 2">
  <app-commercial-evaluation-criteria
    [data]="data"
  ></app-commercial-evaluation-criteria>
  </ng-container>
</div>
